var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAd02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42.3489V8.5708L49.2857 8.56836V32.2083L38.194 44.6866L35.932 42.9898C32.145 40.1497 26.7723 40.9172 23.932 44.7041C22.0954 47.153 21.7673 50.2648 22.7886 52.9263C10.0444 52.5178 0 47.9356 0 42.3489Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.4927V23.3965C0.190912 23.7518 0.5115 24.1695 1.03419 24.6447C2.09879 25.6128 3.78869 26.6076 6.10393 27.4982C10.7166 29.2727 17.2702 30.4275 24.6429 30.4275C32.0156 30.4275 38.5693 29.2727 43.182 27.4982C45.4971 26.6076 47.187 25.6128 48.2516 24.6447C48.7744 24.1696 49.095 23.7519 49.2857 23.3967V30.4928C48.033 31.2474 46.6217 31.9148 45.1054 32.4981C39.7369 34.5634 32.5017 35.7846 24.6429 35.7846C16.7842 35.7846 9.54891 34.5634 4.18047 32.4981C2.6641 31.9148 1.25266 31.2474 0 30.4927Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6393 34.5873C59.9658 35.7667 60.0853 37.7984 58.9059 39.1251L41.7632 58.4108C40.6526 59.6605 38.7696 59.85 37.4323 58.8467L28.8609 52.4181C27.4407 51.3531 27.1529 49.3384 28.218 47.9181C29.2831 46.4982 31.2978 46.2102 32.718 47.2752L38.9234 51.9295L54.1012 34.8543C55.2806 33.5274 57.3125 33.408 58.6393 34.5873Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6429 17.1429C38.2527 17.1429 49.2857 13.3053 49.2857 8.57143C49.2857 3.83756 38.2527 0 24.6429 0C11.033 0 0 3.83756 0 8.57143C0 13.3053 11.033 17.1429 24.6429 17.1429Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAd02);
export default __webpack_public_path__ + "static/media/sub_ad_02.42cb0364b615ac045967e204f94dac19.svg";
export { ForwardRef as ReactComponent };